import { render } from "./PrecinctAssetType.vue?vue&type=template&id=782f2871"
import script from "./PrecinctAssetType.vue?vue&type=script&lang=js"
export * from "./PrecinctAssetType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__